export const holes = {
  1: {
    par: 5,
    length: 532,
    blue: 558,
    white: 532,
    gold: 501,
    rating: 3,
    lrating: 1,
    pace: 17,
    greenback: [46.1871325280127,-83.0199140960104],greencenter: [46.1870055135553,-83.0199593967323],greenfront: [46.186904716182,-83.0199894548655],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-1-900x540.jpg",
  },
  2: {
    par: 4,
    length: 302,
    blue: 314,
    white: 302,
    gold: 262,
    rating: 15,
    lrating: 13,
    pace: 12,
    greenback: [46.1899926924069,-83.0207598211377],greencenter: [46.189899,-83.020609],greenfront: [46.1897560937548,-83.020554156416],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-2-900x540.jpg",
  },
  3: {
    par: 4,
    length: 374,
    blue: 407,
    white: 374,
    gold: 333,
    rating: 5,
    lrating: 3,
    pace: 14,
    greenback: [46.1919920218111,-83.0265382690401],greencenter: [46.1918469569381,-83.0264116407099],greenfront: [46.1917055462023,-83.0263062518236],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-3-900x540.jpg",
  },
  4: {
    par: 4,
    length: 520,
    blue: 411,
    white: 362,
    gold: 327,
    rating: 11,
    lrating: 11,
    pace: 14,
    greenback: [46.191396,-83.021961],greencenter: [46.19137,-83.022166],greenfront: [46.191363,-83.022365],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-4-900x540.jpg",
  },
  5: {
    par: 3,
    length: 128,
    blue: 136,
    white: 128,
    gold: 109,
    rating: 17,
    lrating: 17,
    pace: 9,
    greenback: [46.19026,-83.020593],greencenter: [46.190312,-83.020755],greenfront: [46.190382,-83.0209],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-5-900x540.jpg",
  },
  6: {
    par: 4,
    length: 404,
    blue: 421,
    white: 404,
    gold: 349,
    rating: 1,
    lrating: 5,
    pace: 14,
    greenback: [46.19026,-83.020593],greencenter: [46.190312,-83.020755],greenfront: [46.190382,-83.0209],

    img: "http://www.huronpines.com/wp-content/uploads/DSCN2109-900x540.jpg",
  },
  7: {
    par: 4,
    length: 377,
    blue: 392,
    white: 377,
    gold: 330,
    rating: 7,
    lrating: 7,
    pace: 14,
    greenback: [46.189747,-83.011807],greencenter: [46.189707,-83.011972],greenfront: [46.189669,-83.012147],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-7-900x540.jpg",
  },
  8: {
    par: 5,
    length: 514,
    blue: 556,
    white: 514,
    gold: 444,
    rating: 9,
    lrating: 15,
    pace: 17,
    greenback: [46.188416,-83.018527],greencenter: [46.188412,-83.018291],greenfront: [46.188407,-83.018056],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-8-900x540.jpg",
  },
  9: {
    par: 3,
    length: 160,
    blue: 180,
    white: 160,
    gold: 137,
    rating: 13,
    lrating: 9,
    pace: 10,
    greenback: [46.188416,-83.018527],greencenter: [46.188412,-83.018291],greenfront: [46.188407,-83.018056],

    img: "http://www.huronpines.com/wp-content/uploads/Hole-9-900x540.jpg",
  },
  10: {
    par: 4,
    length: 333,
    blue: 396,
    white: 333,
    gold: 290,
    rating: 16,
    lrating: 14,
    pace: 13,
    greenback: [46.187433,-83.018153],greencenter: [46.187287,-83.018168],greenfront: [46.187146,-83.018185],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-10-900x540.jpg",
  },
  11: {
    par: 4,
    length: 160,
    blue: 412,
    white: 402,
    gold: 360,
    rating: 2,
    lrating: 8,
    pace: 15,
    greenback: [46.190228,-83.021964],greencenter: [46.190131,-83.021869],greenfront: [46.189986,-83.021798],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-11-900x540.jpg",
  },
  12: {
    par: 5,
    length: 160,
    blue: 484,
    white: 447,
    gold: 400,
    rating: 4,
    lrating: 10,
    pace: 16,
    greenback: [46.1872145471414,-83.0208755639479],greencenter: [46.1872464787168,-83.0209801167977],greenfront: [46.1872464787168,-83.0209801167977],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-12-900x540.jpg",
  },
  13: {
    par: 3,
    length: 189,
    blue: 229,
    white: 189,
    gold: 147,
    rating: 14,
    lrating: 18,
    pace: 10,
    greenback: [46.1855493366452,-83.0231723341764],greencenter: [46.1855581817913,-83.0230877515058],greenfront: [46.1855817073705,-83.0230149232043],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-13-900x540.jpg",
  },
  14: {
    par: 4,
    length: 366,
    blue: 406,
    white: 366,
    gold: 348,
    rating: 6,
    lrating: 4,
    pace: 14,
    greenback: [46.1892109715556,-83.0242427662712],greencenter: [46.189127,-83.024325],greenfront: [46.1890186024147,-83.0243522399795],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-14-900x540.jpg",
  },
  15: {
    par: 4,
    length: 160,
    blue: 375,
    white: 361,
    gold: 324,
    rating: 8,
    lrating: 8,
    pace: 14,
    greenback: [46.19195,-83.02751],greencenter: [46.191847,-83.027438],greenfront: [46.191736,-83.027362],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-15-900x540.jpg",
  },
  16: {
    par: 4,
    length: 160,
    blue: 329,
    white: 315,
    gold: 267,
    rating: 18,
    lrating: 12,
    pace: 13,
    greenback: [46.1891492920489,-83.0265071952751],greencenter: [46.1892878078788,-83.0265848828775],greenfront: [46.189427,-83.026655],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-16-900x540.jpg",
  },
  17: {
    par: 3,
    length: 189,
    blue: 199,
    white: 189,
    gold: 144,
    rating: 12,
    lrating: 16,
    pace: 10,
    greenback: [46.187788,-83.027094],greencenter: [46.1879150010101,-83.027050111011],greenfront: [46.188006,-83.026911],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-17-900x540.jpg",
  },
  18: {
    par: 5,
    length: 490,
    blue: 558,
    white: 490,
    gold: 480,
    rating: 10,
    lrating: 2,
    pace: 18,
    greenback: [46.1834907056411,-83.0231350972566],greencenter: [46.1835996494243,-83.0233434152333],greenfront: [46.1837135742764,-83.0235193143231],
    img: "http://www.huronpines.com/wp-content/uploads/Hole-18-900x540.jpg",
  },
};
